import { Link } from 'react-router-dom';
import { plotEpisodes } from '@/mocks/plotEpisodes';
import { castMembers } from '@/mocks/castMembers';
import { newsArticles } from '@/mocks/newsArticles';

const entries = [
  {
    key: 'plot',
    path: '/category/plot',
    label: '剧情介绍',
    desc: '十二集分集梳理，从雨夜归来到春天开门',
    count: `${plotEpisodes.length} 集`,
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20long%20dark%20wooden%20corridor%20in%20an%20old%20Chinese%20villa%20with%20deep%20crimson%20panels%20and%20a%20warm%20lamp%20at%20the%20far%20end%2C%20ivory%20floor%20reflections%2C%20elegant%20mysterious%20film%20photography%2C%20no%20text%2C%20restrained%20color%20palette&width=900&height=600&seq=entry-plot&orientation=landscape',
  },
  {
    key: 'cast',
    path: '/category/cast',
    label: '演员名单',
    desc: '八位主创与角色对照，了解每个人的位置',
    count: `${castMembers.length} 位`,
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20backstage%20still%20of%20an%20elegant%20vintage%20dressing%20room%20with%20costume%20racks%20and%20warm%20mirror%20lights%2C%20deep%20crimson%20fabric%2C%20ivory%20walls%2C%20empty%20chair%2C%20refined%20editorial%20photography%2C%20no%20text%2C%20nostalgic%20quiet%20mood&width=900&height=600&seq=entry-cast&orientation=landscape',
  },
  {
    key: 'news',
    path: '/category/news',
    label: '最新动态',
    desc: '收视、访谈与幕后花絮，持续跟进',
    count: `${newsArticles.length} 篇`,
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20desk%20still%20life%20with%20newspapers%2C%20a%20coffee%20cup%20and%20reading%20glasses%20under%20warm%20morning%20light%2C%20ivory%20paper%20tones%20and%20deep%20crimson%20notebook%20accent%2C%20editorial%20photography%2C%20no%20text%2C%20calm%20sophisticated%20atmosphere&width=900&height=600&seq=entry-news&orientation=landscape',
  },
];

export default function CategoryEntries() {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full px-4 py-10 md:px-8 md:py-14">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs tracking-[0.24em] text-primary-600">专题入口</p>
            <h2 className="mt-2 font-heading text-xl text-foreground-950 md:text-2xl">从三个角度，进入这个故事</h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-500">
            剧情按分集整理，演员按姓名首字母检索，动态按时间归档——你可以按自己的方式理解顾家。
          </p>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {entries.map((entry) => (
            <Link
              key={entry.key}
              to={entry.path}
              className="group relative overflow-hidden rounded-lg border border-background-200"
            >
              <div className="h-[190px] w-full overflow-hidden bg-background-200 md:h-[210px]">
                <img
                  src={entry.image}
                  alt={`${entry.label}入口配图`}
                  title={`${entry.label} - 禁止的爱善良的小姨子专题`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/88 via-foreground-950/35 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-5">
                <div className="flex items-center justify-between gap-3">
                  <span className="rounded-sm bg-accent-500 px-2 py-0.5 text-[11px] text-primary-950">
                    {entry.count}
                  </span>
                  <span className="flex h-7 w-7 items-center justify-center rounded-full border border-background-50/40 text-sm text-background-50 transition-colors group-hover:border-accent-400 group-hover:text-accent-300">
                    <i className="ri-arrow-right-up-line" />
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-xl text-background-50">{entry.label}</h3>
                <p className="mt-1 text-xs leading-relaxed text-background-100/75">{entry.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}